import React from "react";
import { useApolloClient } from "@apollo/client";
import { USER_DATA } from "features/common/queries";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { gql } from "@apollo/client";

const USER_DATA_QUERY = gql`
  query userData {
    userData {
      id
      isInternalUser
      countryId
      showAmountsWithVAT
      isExchangeRateFunctionality
      allowIndividualSearch
      allowAutomatedDecision
      showQuestionsInVCP
      showDecisionReasons
      dealerDrivenConsent
      customerDrivenConsent
      requestAlwaysConsent
      allowSoleTraderSearch
      allowInsurance
      allowSelectionInsuranceConvention
      useDownloadProductInStep4
      rights
    }
  }
`;

const UserDataProvider = () => {
  const client = useApolloClient();
  useQueryWithErrorHandling(USER_DATA_QUERY, {
    onCompleted: (r) => {
      client.writeQuery({
        query: USER_DATA,
        data: { userData: r.userData },
      });
    },
  });
  return <></>;
};

export default UserDataProvider;
